define(function(require, exports, module) {
    'use strict';

    var $ = require('j');
    var _ = require('underscore');
    var core = require('core');
    var i18n = require('i18n');
    const user = require('user');
    const serverUtil = require('util/server.util');
    var validationHelpers = require('modules/user/user.validation.helpers');

    module.exports = function() {
        return {
            title: {
                required: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.title.required')
                }
            },
            firstname: {
                required: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.firstname.required')
                },
                length: {
                    min: 2,
                    max: 50,
                    message: i18n.t('playtech.mobile.system.user.tooltip.firstname.length')
                },
                regexp: {
                    regexp: validationHelpers.firstLastNameRe,
                    message: i18n.t('playtech.mobile.system.user.tooltip.firstname.regexp')
                }
            },
            lastname: {
                required: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.lastname.required')
                },
                length: {
                    min: 2,
                    max: 50,
                    message: i18n.t('playtech.mobile.system.user.tooltip.lastname.length')
                },
                regexp: {
                    regexp: validationHelpers.firstLastNameRe,
                    message: i18n.t('playtech.mobile.system.user.tooltip.lastname.regexp')
                }
            },
            registerEmail: {
                required: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.email.required')
                },
                length: {
                    min: 6,
                    max: 100,
                    message: i18n.t('playtech.mobile.system.user.tooltip.email.length')
                },
                ajax: {
                    fn: (function() {
                        let prevEmail; //  used for reduce server request

                        return function ajax($inputs, config, form, dfd) {
                            var email = $inputs.val();
                            var INTERNAL_EMAIL = 'test@playtech.com';
                            var isInternalEmail = email === INTERNAL_EMAIL;
                            const token = user.get('emailAvailabilityVerificationToken');

                            if (email === prevEmail || !$inputs.data('duplicate') || isInternalEmail) {
                                return dfd.resolve();
                            }

                            $inputs
                                .addClass('progress__email')
                                .attr('disabled', 'disabled');

                            Playtech.API.server.checkIfUsernameIsAvailable({
                                email,
                                ...token && { token }
                            })
                                .then(function(data) {
                                    const { emailAvailable } = data;

                                    if (emailAvailable !== 'unavailable') {
                                        prevEmail = email;
                                        dfd.resolve({ data });
                                    } else {
                                        core.trigger('registration:login', email);

                                        dfd.reject({
                                            message: i18n.t('playtech.mobile.system.user.tooltip.email.emailIsInUse')
                                        });
                                    }

                                    $inputs.removeClass('progress__email').removeAttr('disabled');
                                })
                                .catch(function(error) {
                                    const { data: { errorCode } = {} } = error.response || {};

                                    switch (errorCode) {
                                        case -1: {
                                            dfd.resolve(error.response);

                                            break;
                                        }
                                        case 301: {
                                            core.trigger('recaptcha:show', {
                                                input: $inputs[0],
                                                renderOptions: {
                                                    operation: 'checkUsernameAvailability',
                                                    onValidate: (verificationToken) => {
                                                        user.set('emailAvailabilityVerificationToken', verificationToken);
                                                        ajax($inputs, config, form, dfd);
                                                    },
                                                    onError: dfd.reject
                                                }
                                            });
                                            break;
                                        }
                                        default: {
                                            dfd.reject({ message: serverUtil.getErrorMessage(error) });
                                        }
                                    }

                                    if (errorCode !== 301) {
                                        $inputs.removeClass('progress__email').removeAttr('disabled');
                                    }
                                });

                            return dfd;
                        };
                    })(),
                },
                email: true
            },
            email: {
                required: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.email.required')
                },
                length: {
                    min: 6,
                    max: 100,
                    message: i18n.t('playtech.mobile.system.user.tooltip.email.length')
                },
                email: true
            },
            emailVerify: {
                required: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.email.required')
                },
                length: {
                    min: 6,
                    max: 100,
                    message: i18n.t('playtech.mobile.system.user.tooltip.email.length')
                },
                fn: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.emailVerify.fn'),
                    fn: function($inputs, config, form) {
                        var emailVerify = $inputs.val().trim(),
                            email = form.$el.find('input[name="email"]').val();

                        if (email) {
                            email = email.trim();
                        }

                        return email ? emailVerify === email : true;
                    }
                }
            },
            gender: {
                required: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.gender.required')
                }
            },
            address: {
                required: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.address.required')
                },
                length: {
                    min: 2,
                    max: 160,
                    message: i18n.t('playtech.mobile.system.user.tooltip.address.length')
                },
                regexp: {
                    regexp: validationHelpers.addressRe,
                    message: i18n.t('playtech.mobile.system.user.tooltip.address.regexp')
                }
            },
            address2: {
                length: {
                    min: 2,
                    max: 65,
                    message: i18n.t('playtech.mobile.system.user.tooltip.address2.length')
                },
                regexp: {
                    regexp: validationHelpers.addressRe,
                    message: i18n.t('playtech.mobile.system.user.tooltip.address.regexp')
                }
            },
            address3: {
                length: {
                    min: 1,
                    max: 28,
                    message: i18n.t('playtech.mobile.system.user.tooltip.address3.length')
                },
                regexp: {
                    regexp: validationHelpers.addressRe,
                    message: i18n.t('playtech.mobile.system.user.tooltip.address3.regexp')
                }
            },
            country: {
                required: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.country.required')
                }
            },
            state: {
                length: {
                    min: 0,
                    max: 20,
                    message: i18n.t('playtech.mobile.system.user.tooltip.state.length')
                },
                regexp: {
                    regexp: validationHelpers.stateRe,
                    message: i18n.t('playtech.mobile.system.user.tooltip.state.regexp')
                }
            },
            city: {
                required: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.city.required')
                },
                length: {
                    min: 2,
                    max: 20,
                    message: i18n.t('playtech.mobile.system.user.tooltip.city.length')
                },
                regexp: {
                    regexp: validationHelpers.cityRe,
                    message: i18n.t('playtech.mobile.system.user.tooltip.city.regexp')
                }
            },
            zip: {
                required: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.zip.required')
                },
                length: {
                    min: 1,
                    max: 12,
                    message: i18n.t('playtech.mobile.system.user.tooltip.zip.length')
                },
                fn: {
                    fn: function($inputs) {
                        var zip = $inputs.val().replace(/\s/g, '');

                        $inputs.val(zip);

                        return validationHelpers.postcodeRe.test(zip);
                    },
                    message: i18n.t('playtech.mobile.system.user.tooltip.zip.regexp')
                }
            },
            currencyCode: {
                required: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.currencyCode.required')
                }
            },
            userName: {
                required: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.userName.required')
                },
                length: {
                    min: 5,
                    max: 16,
                    message: i18n.t('playtech.mobile.system.user.tooltip.userName.length')
                },
                regexp: {
                    regexp: /^[A-Za-z0-9\-\.\@_\s]+$/,
                    message: i18n.t('playtech.mobile.system.user.tooltip.userName.regexp')
                },
                ajax: {
                    fn: (function() {
                        let prevValue; //  used for reduce server request

                        return function ajax($inputs, config, form, dfd) {
                            const { value } = $inputs[0];
                            const token = user.get('userAvailabilityVerificationToken');

                            if (value === prevValue) {
                                return dfd.resolve();
                            }

                            $inputs
                                .addClass('progress__username')
                                .attr('disabled', 'disabled');

                            Playtech.API.server.checkIfUsernameIsAvailable({
                                userName: value,
                                ...token && { token }
                            })
                                .then(function(data) {
                                    const { usernameAvailable, suggestions = [] } = data;

                                    if (usernameAvailable) {
                                        prevValue = value;
                                        dfd.resolve(data);
                                    } else {
                                        dfd.reject({
                                            message: [
                                                i18n.t('playtech.mobile.system.user.tooltip.username.occupied'),
                                                suggestions.map(s => `<a class="fn-suggestion">${s}</a>`).join(' ')
                                            ].filter(Boolean).join(' ')
                                        });
                                    }

                                    $inputs.removeClass('progress__username').removeAttr('disabled');
                                })
                                .catch(function(error) {
                                    const { data: { errorCode } = {} } = error.response || {};

                                    switch (errorCode) {
                                        case -1: {
                                            dfd.resolve(error.response);
                                            break;
                                        }
                                        case 301: {
                                            core.trigger('recaptcha:show', {
                                                input: $inputs[0],
                                                renderOptions: {
                                                    operation: 'checkUsernameAvailability',
                                                    onValidate: (verificationToken) => {
                                                        user.set('userAvailabilityVerificationToken', verificationToken);
                                                        ajax($inputs, config, form, dfd);
                                                    },
                                                    onError: dfd.reject
                                                }
                                            });
                                            break;
                                        }
                                        default: {
                                            dfd.reject({ message: serverUtil.getErrorMessage(error) });
                                        }
                                    }

                                    if (errorCode !== 301) {
                                        $inputs.removeClass('progress__username').removeAttr('disabled');
                                    }
                                });

                            return dfd;
                        };
                    })()
                }
            },
            password: {
                required: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.password.required')
                },
                length: {
                    min: 8,
                    max: 20,
                    message: i18n.t('playtech.mobile.system.user.tooltip.password.length')
                },
                regexp: {
                    regexp: /^[A-Za-z0-9.@_#$'&+()*`;!?,-\/]+$/,
                    message: i18n.t('playtech.mobile.system.user.tooltip.password.regexp')
                }
            },
            loyaltyPoints: {
                required: {
                    message: i18n.t('playtech.mobile.system.loyaltyRedeem.error.required')
                },
                regexp: {
                    regexp: /^[0-9]+$/,
                    message: i18n.t('playtech.mobile.system.loyaltyRedeem.error.regexp')
                },
                fn: {
                    fn: function($inputs, config, form) {
                        var loyaltyMinValues = form.loyaltyMinValues[form.data()['bonus-type']];

                        if ($inputs.val() < loyaltyMinValues) {
                            this.message = i18n.t('playtech.mobile.system.loyaltyRedeem.error.from', loyaltyMinValues);

                            return false;
                        }
                        if ($inputs.val() > form.loyaltyMaxValue) {
                            this.message =
                                i18n.t('playtech.mobile.system.loyaltyRedeem.error.max', form.loyaltyMaxValue);

                            return false;
                        }

                        return true;
                    }
                }
            },
            coupon: {
                fn: {
                    fn: function($inputs) {
                        var coupon = $inputs.val().trim();

                        if (coupon) {
                            if (coupon.length > 10) {
                                this.message = i18n.t('playtech.mobile.system.user.tooltip.coupon.length');
                                return false;
                            }
                            if (!/^[A-Za-z0-9]+$/.test(coupon)) {
                                this.message = i18n.t('playtech.mobile.system.user.tooltip.coupon.regexp');
                                return false;
                            }
                        }
                        return true;
                    },
                    message: i18n.t('playtech.mobile.system.user.tooltip.coupon.regexp')
                }
            },
            terms: {
                required: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.terms.required')
                }
            },

            depositLimit: {
                regexp: {
                    regexp: validationHelpers.moneyRegex,
                    message: i18n.t('playtech.mobile.system.tooltip.amount')
                },
                fn: {
                    fn: function($inputs, config, form) {
                        var options = form.options.data;
                        var data = _.mapObject(form.data(), Number);
                        var fieldName = $inputs[0].name;
                        var value = Number($inputs.val());
                        var viewFieldTypesMatchStr = 'daydeposit|weekdeposit|monthdeposit';
                        var validationFieldTypesMatchStr = 'day|week|month';

                        // can't be moved to regexp because of Reg builder `internal` type validation supports only fn and ajax
                        if (!validationHelpers.moneyRegex.test($inputs.val())) {
                            this.message = i18n.t('playtech.mobile.system.tooltip.amount');

                            return false;
                        }

                        // check another fields
                        var fields = form.$el.find('[data-validation-type=depositLimit]');
                        if (!fields.length) {
                            fields = form.$el.find('.fn-deposit-limit-generic');
                        }

                        if (!form.validationInProgress) {
                            form.validationInProgress = true;

                            _.each(fields, function(field) {
                                form.validateField($(field), options);
                            });

                            form.validationInProgress = false;
                        }
                        // format to {day:, week:, month:} for easy validation
                        var formattedData = _.keys(data).reduce(function(memo, limitName) {
                            var matched = limitName.match(viewFieldTypesMatchStr);
                            if (matched) {
                                memo[matched[0].split('deposit')[0]] = data[limitName];
                            }
                            return memo;
                        }, {});

                        // check playerMustSetLimits & allPeriodsRequired & noLimitsAllowed
                        var isAllLimitsAreEmpty = function(periods) {
                            return _.every(_.pairs(periods), function(pair) {
                                return pair[1] === 0;
                            });
                        };
                        if (options.playerMustSetLimits) {
                            if (options.allPeriodsRequired && value === 0) {
                                this.message = i18n.t('playtech.mobile.system.tooltip.limits.allRequired');
                                return false;
                            }
                            if (!options.allPeriodsRequired && isAllLimitsAreEmpty(formattedData)) {
                                this.message = i18n.t('playtech.mobile.system.tooltip.limits.oneRequired');
                                return false;
                            }
                        }
                        if (!options.allPeriodsRequired && value === 0) {
                            return true;
                        }

                        // check daily <= weekly <= monthly
                        var currentLimitName = fieldName.match(validationFieldTypesMatchStr)[0];

                        if (!validationHelpers.isFitLimitAmount[currentLimitName](formattedData)) {
                            this.message = i18n.t('playtech.mobile.system.tooltip.limits.error.' + currentLimitName);
                            return false;
                        }

                        // check if predefinedType = 'enabled'
                        if (options && options.predefinedType === 'enabled') {
                            // skip range validation for 'Unlimited' and '0'
                            if (options.noLimitsAllowed && value === Number(options.UNLIMITED_AMOUNT) || value === 0) {
                                return true;
                            }

                            const currency = form.$el.find('.fn-currency').val();
                            let allowedLimits = options.depositLimits?.[options.defaultCurrency]?.allowedLimits.map(Number) || [];

                            // options.depositLimits are set by registration component
                            if (currency) {
                                allowedLimits = options.depositLimits?.[currency]?.allowedLimits.map(Number) || allowedLimits;
                            }

                            // options.allowedLimits are set by deposit limit component
                            if (options.allowedLimits?.length) {
                                allowedLimits = options.allowedLimits?.map(Number) || allowedLimits;
                            }

                            var isEmptyAllowed = options.playerMustSetLimits && !options.allPeriodsRequired;

                            if (options.noLimitsAllowed) {
                                allowedLimits.pop();
                            }
                            // skip range validation if predefined limits are not set
                            if (!allowedLimits.length) {
                                return true;
                            }

                            var min = Math.min.apply(null, allowedLimits);
                            var max = Math.max.apply(null, allowedLimits);

                            if (value < min || value > max) {
                                var tkEnabled = 'playtech.mobile.system.tooltip.enabledType' + (isEmptyAllowed
                                    ? '.empty'
                                    : '');
                                this.message = i18n.t(tkEnabled, min, max);
                                return false;
                            }
                        }
                        // check for Unlimited if not permitted
                        if (!options.noLimitsAllowed && value === Number(options.UNLIMITED_AMOUNT)) {
                            this.message = i18n.t('playtech.mobile.system.tooltip.amount');
                            return false;
                        }

                        return true;
                    }
                }
            },

            betLimit: {
                fn: {
                    fn: function($inputs, config, form) {
                        var options = form.options.data;
                        var betConfig = options.betLimitsConfig;
                        var data = _.mapObject(form.data(), Number);
                        var fieldName = $inputs[0].name;
                        var value = Number($inputs.val());
                        var viewFieldTypesMatchStr = 'daybet|weekbet|monthbet|sessionbet';
                        var validationFieldTypesMatchStr = 'day|week|month|session';

                        // can't be moved to regexp because of Reg builder `internal` type validation supports only fn and ajax
                        if (!validationHelpers.moneyRegex.test($inputs.val())) {
                            this.message = i18n.t('playtech.mobile.system.tooltip.amount');

                            return false;
                        }

                        // check another fields
                        var fields = form.$el.find('[data-validation-type=betLimit]');

                        if (!fields.length) {
                            fields = form.$el.find('.fn-bet-limit-generic');
                        }

                        if (!form.validationInProgress) {
                            form.validationInProgress = true;

                            _.each(fields, function(field) {
                                form.validateField($(field), options);
                            });

                            form.validationInProgress = false;
                        }
                        // format to {day:, week:, month:} for easy validation
                        var formattedData = _.keys(data).reduce(function(memo, limitName) {
                            var matched = limitName.match(viewFieldTypesMatchStr);

                            if (matched) {
                                memo[matched[0].split('bet')[0]] = data[limitName];
                            }

                            return memo;
                        }, {});

                        var isAllLimitsAreEmpty = function(periods) {
                            return _.every(_.pairs(periods), function(pair) {
                                return pair[1] === 0;
                            });
                        };

                        if (betConfig.mandatory && isAllLimitsAreEmpty(formattedData)) {
                            this.message = i18n.t('playtech.mobile.system.tooltip.limits.betLimitRequired');
                            return false;
                        }

                        if (betConfig.mandatory && value === 0) {
                            this.message = i18n.t('playtech.mobile.system.tooltip.limits.allbetLimitsRequired');
                            return false;
                        }

                        // check daily <= weekly <= monthly
                        var currentLimitName = fieldName.match(validationFieldTypesMatchStr)[0];

                        if (!validationHelpers.isFitLimitAmount[currentLimitName](formattedData)) {
                            this.message = i18n.t('playtech.mobile.system.tooltip.limits.error.' + currentLimitName + 'Limit');
                            return false;
                        }

                        if (betConfig.predefinedType === 'enabled') {
                            if (betConfig.noLimitsAllowed && value === Number(betConfig.unlimitedAmount) || value
                                === 0) {
                                return true;
                            }

                            var allowedLimits = betConfig.getPredefinedLimits().map(Number);

                            if (betConfig.noLimitsAllowed) {
                                allowedLimits.pop();
                            }

                            // skip range validation if predefined limits are not set
                            if (!allowedLimits.length) {
                                return true;
                            }

                            var min = Math.min.apply(null, allowedLimits);
                            var max = Math.max.apply(null, allowedLimits);

                            if (value < min || value > max) {
                                var tkEnabled = 'playtech.mobile.system.tooltip.enabledType' + (betConfig.mandatory
                                    ? ''
                                    : '.empty');
                                this.message = i18n.t(tkEnabled, min, max);

                                return false;
                            }
                        }

                        if (!betConfig.noLimitsAllowed && value === Number(betConfig.unlimitedAmount)) {
                            this.message = i18n.t('playtech.mobile.system.tooltip.amount');
                            return false;
                        }

                        return true;
                    }
                }
            },

            lossLimit: {
                fn: {
                    fn: function($inputs, config, form) {
                        var options = form.options.data;
                        var lossConfig = options.lossLimitsConfig;
                        var data = _.mapObject(form.data(), Number);
                        var fieldName = $inputs[0].name;
                        var value = Number($inputs.val());
                        var viewFieldTypesMatchStr = 'dayloss|weekloss|monthloss|sessionloss';
                        var validationFieldTypesMatchStr = 'day|week|month|session';

                        // can't be moved to regexp because of Reg builder `internal` type validation supports only fn and ajax
                        if (!validationHelpers.moneyRegex.test($inputs.val())) {
                            this.message = i18n.t('playtech.mobile.system.tooltip.amount');

                            return false;
                        }

                        // check another fields
                        var fields = form.$el.find('[data-validation-type=lossLimit]');

                        if (!fields.length) {
                            fields = form.$el.find('.fn-loss-limit-generic');
                        }

                        if (!form.validationInProgress) {
                            form.validationInProgress = true;

                            _.each(fields, function(field) {
                                form.validateField($(field), options);
                            });

                            form.validationInProgress = false;
                        }
                        // format to {day:, week:, month:} for easy validation
                        var formattedData = _.keys(data).reduce(function(memo, limitName) {
                            var matched = limitName.match(viewFieldTypesMatchStr);

                            if (matched) {
                                memo[matched[0].split('loss')[0]] = data[limitName];
                            }

                            return memo;
                        }, {});

                        var isAllLimitsAreEmpty = function(periods) {
                            return _.every(_.pairs(periods), function(pair) {
                                return pair[1] === 0;
                            });
                        };

                        if (lossConfig.mandatory && isAllLimitsAreEmpty(formattedData)) {
                            this.message = i18n.t('playtech.mobile.system.tooltip.limits.lossLimitRequired');
                            return false;
                        }

                        if (lossConfig.mandatory && value === 0) {
                            this.message = i18n.t('playtech.mobile.system.tooltip.limits.alllossLimitsRequired');
                            return false;
                        }

                        // check daily <= weekly <= monthly
                        var currentLimitName = fieldName.match(validationFieldTypesMatchStr)[0];

                        if (!validationHelpers.isFitLimitAmount[currentLimitName](formattedData)) {
                            this.message =
                                i18n.t('playtech.mobile.system.tooltip.limits.error.' + currentLimitName + 'Limit');
                            return false;
                        }

                        if (lossConfig.predefinedType === 'enabled') {
                            if (lossConfig.noLimitsAllowed && value === Number(lossConfig.unlimitedAmount) || value
                                === 0) {
                                return true;
                            }

                            var allowedLimits = lossConfig.getPredefinedLimits().map(Number);

                            if (lossConfig.noLimitsAllowed) {
                                allowedLimits.pop();
                            }

                            // skip range validation if predefined limits are not set
                            if (!allowedLimits.length) {
                                return true;
                            }

                            var min = Math.min.apply(null, allowedLimits);
                            var max = Math.max.apply(null, allowedLimits);

                            if (value < min || value > max) {
                                var tkEnabled = 'playtech.mobile.system.tooltip.enabledType' + (lossConfig.mandatory
                                    ? ''
                                    : '.empty');
                                this.message = i18n.t(tkEnabled, min, max);

                                return false;
                            }
                        }

                        if (!lossConfig.noLimitsAllowed && value === Number(lossConfig.unlimitedAmount)) {
                            this.message = i18n.t('playtech.mobile.system.tooltip.amount');
                            return false;
                        }

                        return true;
                    }
                }
            },

            polandID: {
                fn: {
                    message: i18n.t('playtech.mobile.registration.invalidPESEL'),
                    fn: validationHelpers.checkPesel
                }
            },

            romanianID: {
                fn: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.romanianID.invalidID'),
                    fn: function($inputs, config, form, state, event, data) {
                        return validationHelpers.checkRomanianID.call(this, $inputs, config, form, state, event, data);
                    }
                }
            },

            spanishID: {
                fn: {
                    fn: function($inputs, config, form, state, event, data) {
                        return validationHelpers.checkSpanishRules.call(this, $inputs, config, form, state, event, data);
                    }
                }
            },

            portugalID: {
                fn: {
                    fn: function($inputs, config, form, state, event, data) {
                        return validationHelpers.checkPortugalRules.call(this, $inputs, config, form, state, event, data);
                    }
                }
            },

            southAfricanID: {
                fn: {
                    message: i18n.t('playtech.mobile.registration.invalidsouthafricanid'),
                    fn: function($inputs, config, form, state, event, data) {
                        return validationHelpers.checkSouthAfricanRules.call(this, $inputs, config, form, state, event, data);
                    }
                }
            },

            italianID: {
                fn: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.italianID.invalid'),
                    fn: function($inputs, config, form, state, event, data) {
                        return validationHelpers.checkItalianRules.call(this, $inputs, config, form, state, event, data);
                    }
                }
            },

            bankId: {
                required: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.bankId.empty')
                },
                length: {
                    min: 10,
                    max: 12,
                    message: i18n.t('playtech.mobile.system.user.tooltip.bankId.length')
                },
                regexp: {
                    regexp: /^[0-9]+$/,
                    message: i18n.t('playtech.mobile.system.user.tooltip.bankId.invalid')
                }
            },

            addressLookup: {
                fn: {
                    fn: function($inputs, config, form) {
                        return validationHelpers.addressLookupValidateFn.call(this, $inputs, config, form);
                    }
                }
            },

            addressLookupSwiss: {
                fn: {
                    fn: function($inputs, config, form) {
                        return validationHelpers.addressLookupSwissValidateFn.call(this, $inputs, config, form);
                    }
                }
            },

            iban: {
                fn: {
                    fn: function($inputs, config, form, state, event, data) {
                        return validationHelpers.validateIban.call(this, $inputs, config, form, state, event, data);
                    }
                }
            },

            phone: {
                fn: {
                    fn: () => true
                }
            }
        };
    };
});
